import React, { useMemo } from 'react';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import selectFormatDate from 'src/utils/selectDateFormat';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';
import GetAppIcon from '@mui/icons-material/GetApp';
import dateFormatType from 'src/utils/dateFormatType';
import getFileFromExternalLink from 'src/utils/document';
import { Link } from 'react-router-dom';

const BureauReportActions = {
  DOWNLOAD_TXT: 'DOWNLOAD_TXT',
  DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL'
};

const MonthlyReportRow = ({
  id,
  period,
  upToDateContractsCount,
  overdueContractsCount,
  document,
  excelDocument
}) => {
  const handleClickOption = action => {
    if (action === BureauReportActions.DOWNLOAD_EXCEL && excelDocument) {
      getFileFromExternalLink(
        excelDocument.documentUrl,
        `Reporte de buró ${period}.xlsx`
      );
    } else {
      getFileFromExternalLink(document.documentUrl, `Reporte de buró ${period}`);
    }
  };

  const getMoreMenuOptions = useMemo(() => {
    const options = [
      {
        name: BureauReportActions.DOWNLOAD_TXT,
        label: 'BUREAU_REPORTS.DOWNLOAD_TXT',
        icon: <GetAppIcon />
      }
    ];

    if (excelDocument) {
      options.push({
        name: BureauReportActions.DOWNLOAD_EXCEL,
        label: 'BUREAU_REPORTS.DOWNLOAD_EXCEL',
        icon: <GetAppIcon />
      });
    }

    return options;
  }, [excelDocument]);

  return (
    <TableRow hover>
      <TableCell align="center">
        <Link to={`/income/bureau-reports/detail/${id}`}>
          {selectFormatDate(period, dateFormatType.MONTH_AND_YEAR)}
        </Link>
      </TableCell>
      <TableCell align="center">{upToDateContractsCount}</TableCell>
      <TableCell align="center">{overdueContractsCount}</TableCell>
      <TableCell align="right">
        <MoreMenu
          deleteDisabled
          editDisabled
          options={getMoreMenuOptions}
          handleClickOption={handleClickOption}
        />
      </TableCell>
    </TableRow>
  );
};

MonthlyReportRow.propTypes = {
  id: PropTypes.number.isRequired,
  period: PropTypes.string.isRequired,
  upToDateContractsCount: PropTypes.number.isRequired,
  overdueContractsCount: PropTypes.number.isRequired,
  document: PropTypes.shape({ documentUrl: PropTypes.string }).isRequired,
  excelDocument: PropTypes.shape({ documentUrl: PropTypes.string })
};

MonthlyReportRow.defaultProps = {
  excelDocument: null
};

export default MonthlyReportRow;
